export default class TicketCategoriaStatusEnum {
  static Novo = 1
  static Andamento = 2
  static Resolvido = 3
  static Finalizado = 4
}
